import { Drawer, Grid2 } from "@mui/material";
import { useState, useEffect } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { useParams, useNavigate } from "react-router-dom";
import { DataTypeEnum } from "../../_common/enum/dataType.enum";
import { FormTemplateTypeEnum } from "../../_common/enum/forms/fomTemplateType.enum";
import { DataTypeAutoComplete } from "../../_components/autocomplete/dataType.autocomplete";
import { StandardButton } from "../../_components/button/primary.button";
import { DrawerHeader } from "../../_components/drawer/header.drawer";
import { toastr } from "../../_components/toastr/toastr";
import { handleErrorResponse } from "../../_helpers/handleResponse.helper";
import { formService } from "../../_services/form.service";
import { StandardTextValidator } from "../../_components/textValidator/standardTextValidator";



export const FormManageDrawer = (params: { formType: FormTemplateTypeEnum, isOpen?: boolean, onClose(): void, id: any }) => {
    const { id } = useParams<{ id: string }>();

    const resetData = () => ({
        id: params.id, formTemplateId: 0
    });

    var url = params.formType == FormTemplateTypeEnum.Centre ? '/Centre/Details/' : params.formType == FormTemplateTypeEnum.Client ? '/Client/Details/' : '';
    const [data, setData] = useState<any>(resetData());
    const [isLoading, setIsLoading] = useState(false);
    const [saving, setIsSaving] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        setData(resetData);
    }, [id]);

    useEffect(() => {
        if (isOpen == false)
            setIsOpen(true);
    }, []);



    function craeteForm(e: any) {
        e.preventDefault();
        setIsSaving(true);
        return formService
            .createByType(data, params.id)
            .then(
                (json: any) => {
                    toastr.success("Saved successfully");
                    resetData();
                    navigate(`${url}${params.id}/Forms/` + json);
                }, handleErrorResponse
            )
            .finally(() => setIsSaving(false));
    }


    function handleChange(event: any) {
        setData((_data: any) => ({ ..._data, [event.target.name]: event.target.value }));
    }

    return (
        <Drawer
            anchor={"right"}
            variant="persistent"
            open={isOpen}
            ModalProps={{
                keepMounted: true
            }}>

            <DrawerHeader name={"Select Form Template"} onClose={params.onClose} />

            <ValidatorForm
                onSubmit={craeteForm}
                noValidate>

                <Grid2 container spacing={1} sx={{ "padding": "8px" }}>
                    <Grid2 size={{ xs: 12 }}>
                        <StandardTextValidator
                            key="topic"
                            name="topic"
                            label="Topic"
                            fullWidth
                            value={data.topic}
                            onChange={handleChange}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12 }}>
                        <DataTypeAutoComplete
                            parentId={params.formType}
                            name="formTemplateId"
                            label="Template Type"
                            required
                            value={data.formTemplateId}
                            onChange={handleChange} dataType={DataTypeEnum.FormTemplate} />
                    </Grid2>
                    <Grid2 size={{ xs: 12 }}>
                        <Grid2 container spacing={1}>
                            <Grid2 size={{ xs: 12 }}>
                                <StandardButton
                                    saving={saving}
                                    loading={isLoading}
                                    icon="edit"
                                    type="submit"
                                    variant="success">
                                    {"Create the form"}
                                </StandardButton>
                            </Grid2>
                        </Grid2>
                    </Grid2>
                </Grid2>

            </ValidatorForm>
        </Drawer>
    );
};